var __TEMP__ = require('./_overArg.js');var overArg = __REQUIRE_DEFAULT__(__TEMP__);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = nativeKeys;
